import { General } from "../../siteManagement/general";
import { SheetEventType } from "../../siteManagement/sheet";
import PanelBar from "../core/components/panelBar";
import { Helper } from "../core/util/helper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { NotificationHelper } from "../core/util/notificationHelper";
import React from "react";
export default class ResourcePlanningHourlyRate extends React.Component<any, {
    costs: any;
    value: any;
}>{
    private radioGroup: kendo.ui.RadioGroup;

    constructor(props) {
        super(props);
        this.state = {
            costs: null,
            value: this.props.entity.Stundensatz.toString()
        }
    }

    componentDidMount() {
        this.loadExpeses();
    }

    componentDidUpdate() {
        if (this.props.entity.Stundensatz != this.state.value && this.radioGroup)
            this.setState({ value: this.props.entity.Stundensatz }, () => {
                $("input[name='hourlyRateRadioGroup']").prop("checked", false);
                this.radioGroup.value(this.state.value);
            });
    }

    private loadExpeses = async () => {
        if (!this.props.entity.ProjNr || !this.props.entity.PIndex)
            return;

        let result = await HTTPService.get<JsonResultClass<any>>("ResourcePlanningLookUp/GetCosts?"
            + "projNr=" + encodeURIComponent(this.props.entity.ProjNr)
            + "&pIndex=" + encodeURIComponent(this.props.entity.PIndex)
            + "&ressNr=" + encodeURIComponent(this.props.entity.RessNr ?? "")
            + "&grNr=" + encodeURIComponent(this.props.entity.GrNr));

        if (result.Code == 0) {
            this.setState({ costs: result.Data }, this.createRadioGroup);
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private createRadioGroup = () => {
        this.radioGroup = $("#hourlyRateRadioGroup").kendoRadioGroup({
            items: [
                {
                    value: this.state.costs["TravelHourRate"] ?? "-",
                    label: `${this.state.costs["TravelHourRate"] ?? "-"} (${Helper.getTranslation("Field.Ressource.kostenfahrtstunde")})`,
                    enabled: this.props.entity.RecordRight.CanWrite && this.state.costs["TravelHourRate"]
                },
                {
                    value: this.state.costs["HourlyRate"],
                    label: `${this.state.costs["HourlyRate"] ?? "-"} (${Helper.getTranslation("Field.Ressource.stundensatz")})`,
                    enabled: this.props.entity.RecordRight.CanWrite && this.state.costs["HourlyRate"]
                }
            ],
            value: this.state.value,
            change: (e) => {
                this.setState({ value: e.newValue }, () => {
                    General.Sheet.Manager.getTopMostSheet().trigger(SheetEventType.Custom, { command: "houlyRateChanged", value: this.state.value })
                });
            }
        }).data("kendoRadioGroup");
    }

    render() {
        return <PanelBar headerText={Helper.getTranslation("Field.Einsatz.HourlyRateSelection")} iconName="search" onExpand={() => { this.loadExpeses() }}>
            <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
                <ul id="hourlyRateRadioGroup"></ul>
            </div>
        </PanelBar>;
    }
}